import type { SuppliersEntity } from '@eliadmin/core/src/api/products/types/product-types';
import { ProductSupplierItem } from '@eliadmin/core/src/components/product/detail/product-supplier-item';
import { ProductSuppliersSort } from '@eliadmin/core/src/components/product/detail/product-suppliers-sort';
import { Container } from '@eliadmin/core/src/components/ui/container';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useMemo } from 'react';

export function ProductTabSuppliers() {
  const product = useVariantsStore(s => s.product);

  const { t } = useTranslations();

  const sortedSuppliers = useMemo(
    () => [...product.suppliers].sort((a, b) => a.position - b.position),
    [product.suppliers],
  );

  return (
    <Container className={cn('flex flex-col px-2', 'ea-product-detail-tab-suppliers')}>
      <div className="mb-4 flex w-full flex-col justify-between gap-6 sm:flex-row">
        <h2 className="text-2xl font-bold">{t('text718')}</h2>
        <ProductSuppliersSort />
      </div>
      <div className="flex flex-col gap-2">
        {sortedSuppliers.map((supplier: SuppliersEntity, index: number) => (
          <ProductSupplierItem key={supplier.id ?? supplier.name ?? index} supplier={supplier} />
        ))}
      </div>
    </Container>
  );
}
